<template>
    <div id="view3" style="min-width:400px;height:400px"></div>
</template>

<script>
import * as echarts from "echarts";
export default {
    data() {
        return {
            isshow: false,
            myChart: null
        };
    },
    methods: {
        screenWidth() {
            this.myChart.resize();
        },
        getData(date, data, data1) {
            if (this.isshow) {
                return this.screenWidth();
            }
            this.isshow = true;
            this.viewCharts(date, data, data1);
        },
        viewCharts(date, obj) {
            this.myChart = echarts.init(document.getElementById("view3"));
            let option = {
                tooltip: {
                    trigger: "axis",
                    backgroundColor: "rgba(0, 0, 0, 0.6)",
                    borderColor: "rgba(0, 0, 0, 0.6)",
                    textStyle: {
                        color: "rgb(255, 255, 255)"
                    },
                    axisPointer: {
                        animation: false
                    }
                },
                title: {
                    text: "个",
                    textStyle: {
                        color: "#aaa",
                        fontStyle: "normal",
                        fontSize: "12",
                        lineHeight: 50
                    },
                    left: "2%"
                },
                grid: {
                    left: "2.5%",
                    right: "2.5%"
                },
                xAxis: {
                    type: "category",
                    data: date
                },
                yAxis: {
                    type: "value"
                },
                dataZoom: [
                    {
                        type: "inside",
                        start: 80,
                        end: 100
                    },
                    {
                        start: 80,
                        end: 100
                    }
                ],
                series: [
                    {
                        name: "1星",
                        type: "line",
                        data: obj.data1,
                        showAllSymbol: false,
                        itemStyle: {
                            color: "rgb(204, 44, 35)"
                        },
                        lineStyle: {
                            color: "rgb(204, 44, 35)"
                        },
                        stack: "总量",
                        areaStyle: {
                            opacity: 0.8,
                            color: new echarts.graphic.LinearGradient(
                                0,
                                0,
                                0,
                                1,
                                [
                                    {
                                        offset: 1,
                                        color: "rgb(219, 107, 101)"
                                    }
                                ]
                            )
                        },
                        emphasis: {
                            lineStyle: {
                                width: 2
                            }
                        }
                    },
                    {
                        name: "2星",
                        type: "line",
                        stack: "总量",
                        data: obj.data2,
                        showAllSymbol: false,
                        areaStyle: {
                            opacity: 0.8,
                            color: new echarts.graphic.LinearGradient(
                                0,
                                0,
                                0,
                                1,
                                [
                                    {
                                        offset: 1,
                                        color: "rgb(131, 155, 170)"
                                    }
                                ]
                            )
                        },
                        itemStyle: {
                            color: "rgb(79, 112, 134)"
                        },
                        lineStyle: {
                            color: "rgb(79, 112, 134)"
                        },
                        emphasis: {
                            lineStyle: {
                                width: 2
                            }
                        }
                    },
                    {
                        name: "3星",
                        type: "line",
                        stack: "总量",
                        data: obj.data3,
                        showAllSymbol: false,
                        areaStyle: {
                            opacity: 0.8,
                            color: new echarts.graphic.LinearGradient(
                                0,
                                0,
                                0,
                                1,
                                [
                                    {
                                        offset: 1,
                                        color: "rgb(151, 229, 208)"
                                    }
                                ]
                            )
                        },
                        itemStyle: {
                            color: "rgb(107, 218, 188)"
                        },
                        lineStyle: {
                            color: "rgb(107, 218, 188)"
                        },
                        emphasis: {
                            lineStyle: {
                                width: 2
                            }
                        }
                    },
                    {
                        name: "4星",
                        type: "line",
                        stack: "总量",
                        data: obj.data4,
                        showAllSymbol: false,
                        areaStyle: {
                            opacity: 0.8,
                            color: new echarts.graphic.LinearGradient(
                                0,
                                0,
                                0,
                                1,
                                [
                                    {
                                        offset: 1,
                                        color: "rgb(242, 171, 135)"
                                    }
                                ]
                            )
                        },
                        itemStyle: {
                            color: "rgb(237, 136, 84)"
                        },
                        lineStyle: {
                            color: "rgb(237, 136, 84)"
                        },
                        emphasis: {
                            lineStyle: {
                                width: 2
                            }
                        }
                    },
                    {
                        name: "5星",
                        type: "line",
                        stack: "总量",
                        data: obj.data5,
                        showAllSymbol: false,
                        areaStyle: {
                            opacity: 0.8,
                            color: new echarts.graphic.LinearGradient(
                                0,
                                0,
                                0,
                                1,
                                [
                                    {
                                        offset: 1,
                                        color: "rgb(133, 209, 239)"
                                    }
                                ]
                            )
                        },
                        itemStyle: {
                            color: "rgb(81, 190, 232)"
                        },
                        lineStyle: {
                            color: "rgb(81, 190, 232)"
                        },
                        emphasis: {
                            lineStyle: {
                                width: 2
                            }
                        }
                    }
                ]
            };
            // 绘制图表
            this.myChart.setOption(option);
        }
    }
};
</script>

<style type="text/scss" lang="scss" scoped>
</style>
